import { render, staticRenderFns } from "./auth.vue?vue&type=template&id=c805eb6e&scoped=true&"
import script from "./auth.vue?vue&type=script&lang=ts&"
export * from "./auth.vue?vue&type=script&lang=ts&"
import style0 from "./auth.vue?vue&type=style&index=0&id=c805eb6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c805eb6e",
  null
  
)

export default component.exports